var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/system';
import classNames from 'classnames';
import { AnimatePresence, motion, useCycle } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';
var StyledDigit = styled('div', {
    shouldForwardProp: function (prop) { return prop !== 'extraStyles'; },
})(function (_a) {
    var theme = _a.theme, extraStyles = _a.extraStyles;
    return (__assign({ textAlign: 'center', padding: '.25rem', minHeight: '2.5rem', fontSize: '1.2rem', overflow: 'hidden' }, extraStyles));
});
export var Digit = function (_a) {
    var value = _a.value, className = _a.className, extraStyles = _a.extraStyles, index = _a.index, activeIndex = _a.activeIndex;
    var variants = {
        hidden: {
            scale: 0,
            y: 30,
            opacity: 0,
        },
        active: {
            scale: 1,
            y: 0,
            opacity: 1,
        },
        exit: {
            scale: 0,
            y: 30,
            opacity: 0,
        },
    };
    return (_jsx(AnimatedDigit, __assign({ extraStyles: extraStyles, state: activeIndex === index ? 'blinking' : value ? 'active' : 'inactive', className: classNames({ 'has-value': !!value }) }, { children: _jsx(AnimatePresence, { children: value && (_jsx(motion.div, __assign({ variants: variants, initial: "hidden", animate: "active", exit: "exit", transition: { type: 'spring', duration: 0.4 } }, { children: value }))) }) })));
};
export default Digit;
var AnimatedDigit = function (_a) {
    var state = _a.state, children = _a.children, extraStyles = _a.extraStyles;
    var _b = useState(false), isBlinking = _b[0], setIsBlinking = _b[1];
    var _c = useCycle(true, false), blink = _c[0], cycleBlink = _c[1];
    useInterval(function () { return cycleBlink(); }, isBlinking ? 500 : null);
    useEffect(function () {
        if (state === 'blinking')
            setIsBlinking(true);
        else {
            setIsBlinking(false);
            cycleBlink(0);
        }
        switch (state) {
            case 'active':
                setIsBlinking(false);
                cycleBlink(0);
                break;
            case 'blinking':
                setIsBlinking(true);
                break;
            case 'inactive':
            default:
                setIsBlinking(false);
                cycleBlink(1);
                break;
        }
    }, [state]);
    return (_jsx(StyledDigit, __assign({ extraStyles: extraStyles, className: classNames({ 'has-value': state === 'active' }), style: {
            borderBottomStyle: blink ? 'solid' : 'none',
        } }, { children: children })));
};
